import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { SessionInfo } from '../../data/authentication-info';
import { createAction } from '../create-action';
import { CurrentScorecardActions } from '../scorecard/current-scorecard-actions';
import { ServerInfoActions } from '../server/serverinfo-actions';
import { SessionActions } from '../session/session-actions';
import { ScorerStateActions } from './scorer-state-actions';

// import { concatLatestFrom, createEffect } from 'node_modules/@ngrx/effects';
import { map, pluck, tap } from 'rxjs/operators';
/**
 * Created by ashok on 15/05/17.
 */
@Injectable()
export class ScorerStateEffects {
    constructor(private actions$: Actions,
        private sessionActions: SessionActions,
        private scorerStateActions: ScorerStateActions) {
    }
    onLoginFailed$ = createEffect(() =>
        this.actions$.pipe(
            ofType(SessionActions.LOGIN_FAILED),
            map((action: any) => action.payload),
            pluck('exception'),
            map((error: any) => { return createAction(ScorerStateActions.SET_ERROR, error) })
        ),
        {
            dispatch: false,
        }
    );

    onServerClientMismatch$ = createEffect(() =>
        this.actions$.pipe(
            ofType(ServerInfoActions.SERVER_INFO_MISMATCH_CLIENT),
            map((action: any) => action.payload),
            map((missmatch: string) => {
                return createAction(ScorerStateActions.SET_ERROR, missmatch);
            })),
        {
            dispatch: false,
        }
    );


    onClubOrOrganizerLoggedIn$ = createEffect(() =>
        this.actions$.pipe(
            ofType(SessionActions.ORGANIZER_LOGGED_IN, SessionActions.CLUB_LOGGED_IN),
            map((action: any) => action.payload),
            tap((session: SessionInfo) => {
                if (session.user.userType.toLowerCase() === 'club' || session.user.userType.toLowerCase() === 'caddy' || session.user.userType.toLowerCase() === 'partner') {
                    this.scorerStateActions.clubLoggedIn(session);
                } else if (session.user.userType.toLowerCase() === 'organizer') {
                    this.scorerStateActions.organizerLoggedIn(session);
                }
            })),
        {
            dispatch: false,
        }
    );


    onLogout$ = createEffect(() =>
        this.actions$.pipe(
            ofType(SessionActions.LOGOUT),
            map((action: any) => { return createAction(ScorerStateActions.RESET) })),
        {
            dispatch: false,
        }
    );


    onOtherUsersLoggedIn$ = createEffect(() =>
        this.actions$.pipe(
            ofType(SessionActions.PLAYER_LOGGED_IN, SessionActions.ADMIN_LOGGED_IN),
            map((action: any) => action.payload),
            map((session: SessionInfo) => {
                if (session.user.userType.toLowerCase() === 'player' && session.organizerId) {
                    session.user.userType = 'Organizer';
                    return createAction(SessionActions.ORGANIZER_LOGGED_IN, session);
                }
                else {
                    return createAction(ScorerStateActions.SET_USER_TYPE, session.user.userType);
                }
            })),
        {
            dispatch: false,
        }
    );



    onCurrentScorecard$ = createEffect(() =>
        this.actions$.pipe(
            ofType(CurrentScorecardActions.FETCHED_CURRENT_SCORECARD, CurrentScorecardActions.NO_CURRENT_SCORECARD), tap((action: any) => {
                this.scorerStateActions.checkCompetitionScorecard(action.payload);
            })
        ), { dispatch: false });


}
